// ============================================================================
// API Service Barrel — Phase 68 M2 Task 2.1
//
// Backward-compatible re-export of all API functions.
// Consumers can continue using: import { apiClient } from '@services/api'
// New consumers should import from specific modules:
//   import { createJob } from '@services/jobApi'
// ============================================================================

import { normalizeError, httpGet, httpPost, httpPut, httpDelete } from './apiClient'
import * as authApi from './authApi'
import * as chatApi from './chatApi'
import * as knowledgeApi from './knowledgeApi'
import * as userApi from './userApi'
import * as candidateApi from './candidateApi'
import * as employeeApi from './employeeApi'
import * as jobApi from './jobApi'
import * as skillsApi from './skillsApi'
import * as pdfApi from './pdfApi'
import * as projectApi from './projectApi'
import * as clientApi from './clientApi'
import * as metricsApi from './metricsApi'
import * as platformApi from './platformApi'
import axios from 'axios'
import toast from 'react-hot-toast'
import { bffBaseURL } from './apiClient'

// Dead code preserved for backward compat (DashboardPage deleted in M1)
async function getDashboard() {
  try {
    const response = await axios.get(
      `${bffBaseURL}/api/dashboard`
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      toast.error('Failed to load dashboard data')
    }
    throw error
  }
}

// Backward-compatible apiClient object — preserves all method names from original api.js
export const apiClient = {
  // Auth
  ...authApi,
  // Chat
  ...chatApi,
  // Knowledge
  ...knowledgeApi,
  // Users
  ...userApi,
  // Candidates
  ...candidateApi,
  // Employees
  ...employeeApi,
  // Jobs + Pipeline + Matching
  ...jobApi,
  // Skills
  ...skillsApi,
  // PDF
  ...pdfApi,
  // Projects + Assignments
  ...projectApi,
  // Clients + Areas + Client Names
  ...clientApi,
  // Metrics
  ...metricsApi,
  // Platform (Phase 68 M5)
  ...platformApi,
  // Shared utilities
  normalizeError,
  getDashboard,
  // Generic HTTP methods (backward compat — mapped from class methods)
  get: httpGet,
  post: httpPost,
  put: httpPut,
  delete: httpDelete,
}

// Re-export all domain modules for direct import
export * from './authApi'
export * from './chatApi'
export * from './knowledgeApi'
export * from './userApi'
export * from './candidateApi'
export * from './employeeApi'
export * from './jobApi'
export * from './skillsApi'
export * from './pdfApi'
export * from './projectApi'
export * from './clientApi'
export * from './metricsApi'
export * from './platformApi'
export { normalizeError } from './apiClient'
